import { NameSummaryFormDE } from '@/components/slides/DataSummary/de/SummaryForms/NameSummaryFormDE.tsx';
import { ContactSummaryFormDE } from '@/components/slides/DataSummary/de/SummaryForms/ContactSummaryFormDE.tsx';
import { AddressSummaryFormDE } from '@/components/slides/DataSummary/de/SummaryForms/AddressSummaryFormDE.tsx';
import { PersonalInfoSummaryFormDE } from '@/components/slides/DataSummary/de/SummaryForms/PersonalInfoSummaryFormDE.tsx';
import { AncestrySummaryFormDE } from '@/components/slides/DataSummary/de/SummaryForms/AncestrySummaryFormDE.tsx';

export const SummaryFormsDE = () => {
  return (
    <>
      <NameSummaryFormDE />
      <ContactSummaryFormDE />
      <AddressSummaryFormDE />
      <PersonalInfoSummaryFormDE />
      <AncestrySummaryFormDE />
    </>
  );
};
